// extracted by mini-css-extract-plugin
export default {"component":"sheet-modal_component__KVyuT","trigger":"sheet-modal_trigger__lACTH","container":"sheet-modal_container__ZKdrQ"};